__turbopack_context__.v({
  "DM_12_24_Link_B": "MarkdownText-module-scss-module__rhk6sa__DM_12_24_Link_B",
  "DM_14_24_Link_B": "MarkdownText-module-scss-module__rhk6sa__DM_14_24_Link_B",
  "DM_20_24_Bold": "MarkdownText-module-scss-module__rhk6sa__DM_20_24_Bold",
  "DM_Body_Reg_16": "MarkdownText-module-scss-module__rhk6sa__DM_Body_Reg_16",
  "DM_Bold_14_16": "MarkdownText-module-scss-module__rhk6sa__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "MarkdownText-module-scss-module__rhk6sa__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "MarkdownText-module-scss-module__rhk6sa__DM_Bold_16_24",
  "DM_Bold_20_24": "MarkdownText-module-scss-module__rhk6sa__DM_Bold_20_24",
  "DM_Bold_40_56": "MarkdownText-module-scss-module__rhk6sa__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "MarkdownText-module-scss-module__rhk6sa__DM_Btn_16_16_Med",
  "DM_Med_10_12": "MarkdownText-module-scss-module__rhk6sa__DM_Med_10_12",
  "DM_Med_12_12_Chip": "MarkdownText-module-scss-module__rhk6sa__DM_Med_12_12_Chip",
  "DM_Med_12_16": "MarkdownText-module-scss-module__rhk6sa__DM_Med_12_16",
  "DM_Med_14_16": "MarkdownText-module-scss-module__rhk6sa__DM_Med_14_16",
  "DM_Med_14_20": "MarkdownText-module-scss-module__rhk6sa__DM_Med_14_20",
  "DM_Med_14_24": "MarkdownText-module-scss-module__rhk6sa__DM_Med_14_24",
  "DM_Med_16_16": "MarkdownText-module-scss-module__rhk6sa__DM_Med_16_16",
  "DM_Med_16_24": "MarkdownText-module-scss-module__rhk6sa__DM_Med_16_24",
  "DM_Med_18_24": "MarkdownText-module-scss-module__rhk6sa__DM_Med_18_24",
  "DM_Med_20_24": "MarkdownText-module-scss-module__rhk6sa__DM_Med_20_24",
  "DM_Med_24_24": "MarkdownText-module-scss-module__rhk6sa__DM_Med_24_24",
  "DM_Med_32_32": "MarkdownText-module-scss-module__rhk6sa__DM_Med_32_32",
  "DM_Med_32_48": "MarkdownText-module-scss-module__rhk6sa__DM_Med_32_48",
  "DM_Med_8_8": "MarkdownText-module-scss-module__rhk6sa__DM_Med_8_8",
  "DM_Reg_10_10": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_12_16",
  "DM_Reg_14_16": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_14_16",
  "DM_Reg_14_24": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_16_20",
  "DM_Reg_16_24": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_18_28",
  "DM_Reg_32_32": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_32_32",
  "DM_Reg_40_56": "MarkdownText-module-scss-module__rhk6sa__DM_Reg_40_56",
  "container": "MarkdownText-module-scss-module__rhk6sa__container",
});
